module.exports = __webpack_public_path__ + "static/media/certn-logo.00f7f282.svg";